import './../App.css';
import { useEffect, useState, useRef } from 'react';
import carrieres from '../img/careers.jpg';
import Select from 'react-dropdown-select';
import Axios from 'axios';
// import Slider from '@mui/material/Slider';
// import Box from '@mui/material/Box';
import { apiUrl } from '../constants/Constants';
import DownloadIcon from '../img/download_icon.svg';
import DownloadIcon2 from '../img/download_icon2.svg';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingBar from "react-top-loading-bar";
import { keyboard } from '@testing-library/user-event/dist/keyboard';
import { Loader } from '../components/MainComponents';


// function valuetext(value) {
//     return `${value}°C`;
// }

function Carrieres() {
    const ref = useRef(null);

    const [prenom, setPrenom] = useState("");
    const [nom, setNom] = useState("");
    const [email, setEmail] = useState("");
    const [telephone, setTelephone] = useState("");
    const [linkedin, setLinkedin] = useState("");
    const [pretentions, setPretentions] = useState("");
    const [disponibilite, setDisponibilite] = useState("");
    const [cvfile, setCvfile] = useState("");
    const [postulerPour, setPostulerPour] = useState("");
    const [jobDesc, setJobDesc] = useState("");

    const [loading, setLoading] = useState(false)

    const [toastmobile, setToastmobile] = useState(false)

    const [cvfileName, setCvfileName] = useState("aucun fichier choisi");

    const [ind, setInd] = useState([]);

    const [prenomStatus, setPrenomStatus] = useState(false);
    const [nomStatus, setNomStatus] = useState(false);
    const [emailStatus, setEmailStatus] = useState(false);
    const [telephoneStatus, setTelephoneStatus] = useState(false);
    const [cvfileStatus, setCvfileStatus] = useState(false);

    const [prenomError, setPrenomError] = useState("");
    const [nomError, setNomError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [telephoneError, setTelephoneError] = useState("");
    const [cvfileError, setCvfileError] = useState("");

    const [isHidden, setIsHidden] = useState(true);

    const [myimage, setMyimage] = useState(true);

    var formData = new FormData();
    formData.append("emp_Prenom", prenom);
    formData.append("emp_Nom", nom);
    formData.append("emp_Email", email);
    formData.append("emp_Telephone", telephone);
    formData.append("emp_Linkedin", linkedin);
    formData.append("emp_Pretention", pretentions);
    formData.append("emp_Disponibilite", disponibilite);
    // formData.append("emp_cv", cvfile);
    formData.append("emp_posulerPour", postulerPour);
    formData.append("emp_jobTitle", postulerPour);
    formData.append("emp_jobDescription", jobDesc);
    
    const  handlePostuler = async () =>{
        await setIsHidden(false);
        const element = document.getElementById('cvId')
        element.scrollIntoView({  behavior: 'smooth' });
    }

    const handleIndex = (i) => {
        if (ind.includes(i)) {
            setInd(ind.filter(index => index !== i))
        }
        else {
            setInd(prevState => [...prevState, i])
        }
        console.log(ind);
    }


    const changeHandler = (event) => {

        setCvfile(event.target.files[0])
        setCvfileName(event.target.files[0].name)
    };

    const handlePhone = (e) => {
        setTelephone(e.target.value.replace(/[^\d+]/g, ''));
    }

    const telechargerCVApi = () => {


        if (nom === "") {
            setNomStatus(true);
            setNomError("Le nom ne peut pas être vide")
        } else {
            setNomStatus(false)
            setNomError("")
        }
        if (prenom === "") {
            setPrenomStatus(true)
            setPrenomError("Le prenom ne peut pas être vide")
        } else {
            setPrenomStatus(false)
            setPrenomError("")
        }
        if (email === "") {
            setEmailStatus(true)
            setEmailError("L'email ne peut pas être vide")
        }
        else if (!email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
            setEmailStatus(true)
            setEmailError("Mauvais format d'email")
        }
        else {
            setEmailStatus(false)
            setEmailError("")
        }
        if (telephone === "") {
            setTelephoneStatus(true);
            setTelephoneError("Le téléphone ne peut pas être vide")
        }
        else if (telephone.substring(0, 2) !== '00' && telephone.at(0) !== '+') {
            setTelephoneStatus(true);
            setTelephoneError("Le format du numéro de téléphone doit être +XXX  ou 00XXX.")
        }
        else if (telephone.length < 10) {
            setTelephoneStatus(true);
            setTelephoneError("Le numéro de téléphone est trop court")
        }

        else {
            setTelephoneStatus(false)
            setTelephoneError("")
        }
        if (cvfile === "") {
            setCvfileStatus(true)
            setCvfileError("Le CV ne peut pas être vide")
        } else {
            setCvfileStatus(false)
            setCvfileError("")
        }

        if (nom !== "" && prenom !== "" && email !== "" && email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/) && telephone !== "" && cvfile !== "" && !(telephone.substring(0, 2) !== '00' && telephone.at(0) !== '+') && !(telephone.length < 10)) {
            postCv();
        }

    }
    const postCv = () => {

        setLoading(true);

        formData.append("avatar", cvfile);
        Axios.post(apiUrl + 'telechargerCV.php', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(response => {
                toast.success("Votre CV est envoyé");
                setNom('');
                setPrenom('');
                setEmail('');
                setTelephone('');
                setCvfile('');
                setCvfileName('aucun fichier choisi');
                setLoading(false);

            })
            .catch(error => {
                toast.error("Erreur lors de l'envoi du CV")
                setLoading(false);
            });
    }



  
    const handleMailTo = () => {
        window.location.href = 'mailto:people.management.pro-p@linkpact.fr';
      };
    const FileUpload = () => {
        document.getElementById('formFile').click();
    }

    const handleLoadSomething = () => {
        ref.current.continuousStart();
    };

    useEffect(() => {
        handleLoadSomething();
        document.getElementById("nav-acceuil1").classList.remove('navSelected'); document.getElementById("nav-quisommenous1").classList.remove('navSelected'); document.getElementById("nav-nosolutions1").classList.remove('navSelected'); document.getElementById("nav-carrieres1").classList.add('navSelected'); document.getElementById("nav-contactez1").classList.remove('navSelected');
        document.getElementById("nav-acceuil").classList.remove('navSelected'); document.getElementById("nav-quisommenous").classList.remove('navSelected'); document.getElementById("nav-nosolutions").classList.remove('navSelected'); document.getElementById("nav-carrieres").classList.add('navSelected'); document.getElementById("nav-contactez").classList.remove('navSelected');
        document.documentElement.scrollTop = 0;
    }, [])

    useEffect(() => {
        if (loading) {
            document.body.style.overflow = "hidden"
        }
        else {
            document.body.style.overflow = "visible"
        }
    }, [loading]);

    useEffect(() => {

        const handleResize = () => {

            if (window.innerWidth < 500) {
                setToastmobile(true);
            } else {
                setToastmobile(false)
            }
        }

        handleResize();
        window.addEventListener("resize", handleResize);

    }, [window.innerWidth]);

    return (
        <div id='mainCarrieres'>
            <LoadingBar color="#009F6B" ref={ref} />
            {loading && <div class="loader-background"><Loader /></div>}

            <div className='background-img-medium-carrieres' style={{
                backgroundImage: "url(" + carrieres + ")",
                backgroundSize: 'cover',
            }}>
            </div>



            <div class="container list-container">
                <div id='2ndDiv' class="container-fluid carrieresMain">
                    <div class=" alignCenter">
                        <div className='text-title color-blue text-center bold maintitre__carrier'>Vous souhaitez nous rejoindre ?</div>
                    </div>

                    <div class=" text-justify carrieresSoustitre ">
                    Nous recherchons constamment de nouveaux talents ! Si vous souhaitez rejoindre notre équipe d’experts et de passionnés et contribuer à la croissance de notre cabinet, rendez-vous sur notre page LinkedIn pour découvrir nos opportunités actuelles :
                    <span 
                     onClick={() => window.location.href = "https://www.linkedin.com/company/pro-p-group/"}    
                    className='anchorMail' style={{textDecoration:'underline'}}  >Page Linkedin Pro P Group</span>

 
{/* <span onClick={handleMailTo} className='anchorMail'  >  people.management.pro-p@linkpact.fr</span> */}
                    </div>
                    {/* <div class=' qsn-list carreers_list ' style={{display:'flex',alignItems:'flex-start',flexDirection:'column'}}>
                        <div class="qsn-flex" >
                            <div className='bullet_icon' style={{display:'flex',alignItems:'center'}}><i style={{fontSize:'9px'}} class="fas fa-circle"></i></div>
                            <div style={{cursor:'pointer'}} className='anchorMail'   onClick={() => window.location.href = "https://www.linkedin.com/company/pro-p-group/jobs/?viewAsMember=true&lipi=urn%3Ali%3Apage%3Acompanies_company_jobs_jobs%3Bf5491ce0-dc0f-4944-9f5e-04901118c56f"}  >   Consultant Fonctionnel – Expert en Gestion de Projet (BPI) </div>
                        </div>
                        <div class="qsn-flex">
                            <div  className='bullet_icon2' style={{display:'flex',alignItems:'center'}} ><i style={{fontSize:'9px'}} class="fas fa-circle"></i></div>
                            <div style={{cursor:'pointer'}} className='anchorMail' 
                             onClick={() => window.location.href = "https://www.linkedin.com/company/pro-p-group/jobs/?viewAsMember=true&lipi=urn%3Ali%3Apage%3Acompanies_company_jobs_jobs%3Bf5491ce0-dc0f-4944-9f5e-04901118c56f"}  
                            >   Développeur Expérimenté </div>
                        </div>
                        <div class="qsn-flex">
                            <div  className='bullet_icon2' style={{display:'flex',alignItems:'center'}}><i style={{fontSize:'9px'}} class="fas fa-circle"></i></div>
                            <div style={{cursor:'pointer'}} className='anchorMail' 
                        onClick={() => window.location.href = "https://www.linkedin.com/company/pro-p-group/jobs/?viewAsMember=true&lipi=urn%3Ali%3Apage%3Acompanies_company_jobs_jobs%3Bf5491ce0-dc0f-4944-9f5e-04901118c56f"}  

                            >     Ingénieur Développeur - Junior </div>
                        </div> 
                        
                    </div> */}
                </div>
                {/* <div class=" alignCenter" style={{marginTop:'24px'}}>
                        <div className='text-title color-blue  bold' style={{fontSize:'20px'}}>Aucune offre ne correspond à votre profil ?</div>
                    </div> */}
                    
                    <div className=" text-justify carrieresSoustitre  " style={{marginBottom:'50px',position:'relative',left:'7px',marginTop:'24px'}}>
                    <div className='text-title color-blue  bold souscarriere' style={{fontSize:'20px',marginBottom:'8px'}}>Aucune offre ne correspond à votre profil ?</div>

                    N'hésitez pas à nous envoyer votre CV ainsi qu'une lettre de motivation à l'adresse suivante :
<span onClick={handleMailTo} className='anchorMail' style={{textDecoration:'underline'}}  >people.management.pro-p@linkpact.fr</span>
                    </div>
              
            </div>
            {isHidden === true ? (
                <></>
            ) :
                <div class="backgroundGrey">
                    <div id='cvId' class="container carrieresCv">

                        <div class="alignCenter">
                            <div className='text-title color-blue bold'>Télécharger votre CV</div>
                        </div>
                        <form class=" g-3 needs-validation carrieresForm" novalidate>
                            <div class="marginTop30 carrieresInputs">
                                <div class="myinput-label">Nom *</div>

                                <input className='borderInput inputSize' type="text" onChange={(event) => setNom(event.target.value)} value={nom} />

                                {nomStatus === true ? (
                                    <div className='error-p'>{nomError}</div>
                                ) : <></>
                                }
                            </div>
                            <div class="marginTop30 carrieresInputs">
                                <div class="myinput-label">Prénom *</div>

                                <input className='borderInput inputSize' type="text" onChange={(event) => setPrenom(event.target.value)} value={prenom} />

                                {prenomStatus === true ? (
                                    <div className='error-p'>{prenomError}</div>
                                ) : <></>
                                }
                            </div>


                            <div class="marginTop30 carrieresInputs">
                                <div class="">
                                    <div class="myinput-label">Email *</div>

                                    <input className='borderInput inputSize' type="email" onChange={(event) => setEmail(event.target.value)} value={email} />
                                    {emailStatus === true ? (
                                        <div className='error-p'>{emailError}</div>
                                    ) : <></>
                                    }
                                </div>
                            </div>
                            <div class="marginTop30 carrieresInputs">
                                <div class="">
                                    <div class="myinput-label">Téléphone *</div>

                                </div>
                                <input className='borderInput inputSize' type="text" onChange={(event) => handlePhone(event)} value={telephone} onKeyDown={(e) => { telephone == "" ? e.key == '.' && e.preventDefault() : e.key == '+' && e.preventDefault() }} />
                                {telephoneStatus === true ? (
                                    <div className='error-p'>{telephoneError}</div>
                                ) : <></>
                                }
                            </div>
                            <div class="carrieresInputs">
                                <div class="marginTop30 ">
                                    <div class="myinput-label">Télécharger le CV *</div>

                                    <input style={{ display: 'none' }} type="file" name='avatar' id="formFile" onChange={changeHandler} />

                                </div>
                                <div class="borderInput inputSize row-div radius8 carrieresCvInput">
                                    <button type='button' class='inputSize mybtn-size' onClick={() => FileUpload()}>Choisir le fichier</button>
                                    <div class='alignCenter marginLeft10 color-blue cv-name'>{cvfileName}</div>
                                </div>
                                {cvfileStatus === true ? (
                                    <div className='error-p'>{cvfileError}</div>
                                ) : <></>
                                }
                            </div>
                            <div class="marginTop30 carrieresInputs">
                                <div className='myinput-label'>Postuler Pour</div>
                                <input className='borderInputDisable inputSize' type="text" value={postulerPour} placeholder="Candidature spontanée" disabled={true} onChange={(event) => setPostulerPour(event.target.value)} />
                            </div>

                            <div class="marginTop30 qsn-buttons-container" >
                                <div class="">
                                    <button type="button" className='btn-annuler mybtn-size' onClick={() => { setIsHidden(true) }}><div >Annuler</div></button>

                                </div>
                                <div class="">
                                    <button type="button" className='btn-sendMsg mybtn-size' onClick={() => telechargerCVApi()}><div >Postuler</div></button>
                                </div>
                            </div>
                            {toastmobile ? <ToastContainer
                                autoClose={3000}
                                theme="colored"
                                pauseOnHover={false}
                                closeButton={false}
                                hideProgressBar
                                icon={false}
                            /> : <ToastContainer
                                style={{ position: "absolute", top: "50%", right: "-10%", width: "300px" }}
                                autoClose={3000}
                                theme="colored"
                                pauseOnHover={false}
                                closeButton={false}
                                hideProgressBar
                                icon={false}
                            />}
                        </form>
                    </div>
                </div>
            }

            <div class="scroll-top-icon scroll-top myscroll-top cursor-pointer" onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}><i class="fa fa-angle-up fa-2x"></i></div>
        </div >


    );
}

export default Carrieres;
